<template>
	<div class="catalog-footer" :style="`background-color: ${theme.secondary};`">
		<div class="app-container">
			<div class="catalog-footer-container">
				<div class="catalog-footer-total" :style="`color: ${theme.base};`">
					<p class="catalog-footer-total-label">Total:</p>
					<span>
						{{ currency }}{{ total | round }}
					</span>
				</div>
				<a href="#car" class="catalog-footer-car-link">
					<button
						class="catalog-footer-car"
						:style="`background-color: ${theme.accent};`"
						type="button"
					>
						<span
							class="catalog-footer-car-quantity"
							:style="`background-color: ${theme.primary}; color: ${theme.base};`"
						>
							{{ quantity }}
						</span>
						<img
							class="catalog-footer-car-image"
							src="/static/images-new/icons/icon-car.svg"
							alt="carrito de compras"
						/>
					</button>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'catalog-footer',
		props: {
			currency: String,
			quantity: [Number, String],
			theme: {
				default: () => {},
				type: Object,
			},
			total: [Number, String],
		},
	};
</script>

<style lang="scss" scoped>
	.catalog-footer {
		align-items: center;
		bottom: 0px;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		height: 56px;
		position: fixed;
		width: 100%;

		@media (min-width: 936px) {
			height: 84px;
		}

		&-container {
			align-items: center;
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			padding: 0px 15px;

			@media (min-width: 1200px) {
				padding: 0px;
			}
		}

		&-total {
			font-size: size(medium18);
			font-weight: weight(black);
			line-height: 1;

			@media (min-width: 936px) {
				font-size: size(large27);
			}

			&-label {
				font-size: size(medium);
				margin-bottom: 0px;

				@media (min-width: 936px) {
					display: inline-block;
					font-size: size(medium19);
				}
			}
		}

		&-car {
			border-radius: 22px;
			height: 44px;
			margin-left: auto;
			position: relative;
			width: 72px;

			@media (min-width: 936px) {
				border-radius: 31.8px;
				height: 64px;
				width: 104px;
			}

			&-quantity {
				align-items: center;
				border-radius: 100%;
				display: flex;
				font-size: size(caption);
				font-weight: weight(semibold);
				height: 23px;
				justify-content: center;
				position: absolute;
				right: 13px;
				top: 6px;
				width: 23px;

				@media (min-width: 936px) {
					height: 33px;
					right: 18px;
					top: 9px;
					width: 33px;
				}
			}

			&-image {
				height: 24px;
				margin-right: 10px;

				@media (min-width: 936px) {
					height: 34px;
				}
			}
		}

		&-car-link {
			display: block;
			margin-left: auto;
			text-decoration: none;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/catalog/catalog-footer.vue